import { html } from '@microsoft/fast-element';
import { ref, repeat } from '@microsoft/fast-element';
import { getPrefix } from '../utils/dom';
export const getPrefixedDatePicker = (prefix) => html `
  <${prefix}-text-field data-test-id="date-picker" readonly :value="${(x) => x.formatDate}" part="date-toggle" class="date-toggle" ${ref('toggleButton')}>
    ${(x) => x.label}
    <div class="input-icon-container" part="input-icon-container" slot="end"><${prefix}-icon variant="regular" name="calendar-alt" size="sm"></${prefix}-icon></div>
  </${prefix}-text-field>
  <div class="calendar-dropdown ${(x) => x.calendarDropdownClasses} ${(x) => x.position}">
    <div class="header">
      <h3>${(x) => x.currentMonth} ${(x) => x.currentYear}</h3>
      <div class="months-arrows">
        <div class="icon-container" ${ref('prevBtn')}>
          <${prefix}-icon name="angle-left" class="prev-month" aria-label="previous month"></${prefix}-icon>
        </div>
        <div class="icon-container" ${ref('nextBtn')}>
          <${prefix}-icon name="angle-right" class="next-month" aria-label="next month"></${prefix}-icon>
        </div>
      </div>
    </div>
    <div class="week-days">
      ${repeat((x) => x.calendar.weekDays, html `
          <span>${(x, c) => x.substring(0, c.parent.substringNumber)}</span>
        `)}
    </div>
    <div class="month-days" ${ref('calendarDaysContainer')}>
      ${repeat((x) => x.monthList, html `
          <button
            class="month-day 
        ${(x, c) => (c.parent.isSelectedDate(x) ? 'selected' : '')} 
        ${(x, c) => (x.monthNumber === c.parent.calendar.month.number ? 'current' : '')}"
            @click=${(x, c) => c.parent.selectDay(x)}
          >
            ${(x, c) => x.date}
          </button>
        `)}
    </div>
  </div>
`;
export const foundationDatePickerTemplate = html `
  ${(x) => getPrefixedDatePicker(getPrefix(x))}
`;
